import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2e6710f8")

_pushScopeId("data-v-2e6710f8")
const _hoisted_1 = { class: "search-page-view" }
const _hoisted_2 = { class: "search-page-top-view" }
const _hoisted_3 = { class: "search-page-show-area" }
const _hoisted_4 = { class: "search-page-tag-area" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "commonTextBodyDefault search-page-tag-title" }, "絞り込み", -1)
const _hoisted_6 = { class: "search-page-search-tag-area" }
const _hoisted_7 = { class: "search-page-show-list-area" }
const _hoisted_8 = { class: "search-page-count-text" }
const _hoisted_9 = { class: "search-page-sort-area" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "search-page-sort-text" }, "表示順序：", -1)
const _hoisted_11 = { class: "search-page-dropdown-area" }
const _hoisted_12 = { class: "search-page-show-list-2-area" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "commonTextBodyDefault search-page-left-text" }, "検索結果", -1)
const _hoisted_14 = { class: "search-page-icon-area" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "search-page-divider" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CommonRecipeList = _resolveComponent("CommonRecipeList")
  const _component_SearchInputView = _resolveComponent("SearchInputView")
  const _component_SearchRefinedTagList = _resolveComponent("SearchRefinedTagList")
  const _component_SearchDropdownList = _resolveComponent("SearchDropdownList")
  const _component_SearchApplianceIconList = _resolveComponent("SearchApplianceIconList")
  const _component_CommonDialog = _resolveComponent("CommonDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "search-page-recipe-list-area",
      ref: "list",
      onScrollPassive: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onScroll($event)))
    }, [
      _createVNode(_component_CommonRecipeList, {
        class: "search-page-recipe-list",
        style: { 'margin-top': _ctx.getListMerginHeight() },
        key: _ctx.updateDisplayKey,
        recipes: _ctx.searchRecipes,
        onSelectRecipe: _ctx.selectRecipe
      }, null, 8, ["style", "recipes", "onSelectRecipe"])
    ], 544),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "search-page-top-view-area",
        style: { height: _ctx.getTopViewHeight() }
      }, [
        _createVNode(_component_SearchInputView, {
          class: "search-page-text-area",
          inputText: _ctx.getKeyword(),
          onSetFocus: _ctx.setFocusInputView
        }, null, 8, ["inputText", "onSetFocus"]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_SearchRefinedTagList, {
                tags: _ctx.refinedTags,
                onSelectTag: _ctx.selectRefinedTag
              }, null, 8, ["tags", "onSelectTag"])
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, _toDisplayString(_ctx.getCount()), 1),
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_SearchDropdownList, {
                  dropdownList: _ctx.sortDropdownList.list,
                  selectType: _ctx.sortType,
                  onSelectItem: _ctx.selectSort
                }, null, 8, ["dropdownList", "selectType", "onSelectItem"])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode("div", _hoisted_14, [
              _createVNode(_component_SearchApplianceIconList, _mergeProps({ class: "search-page-icon-list" }, _ctx.products, { appliances: _ctx.applianceList }), null, 16, ["appliances"])
            ]),
            _createVNode("div", {
              class: "commonButtonText search-page-right-text",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClickSearchChange()))
            }, " 検索条件を変更 ")
          ]),
          _hoisted_15
        ])
      ], 4)
    ]),
    _createVNode(_component_CommonDialog, {
      showDialog: !!_ctx.handleApiError,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      onNegativeClick: _ctx.closeDialog,
      onPositiveClick: _ctx.retryGetRecipes
    }, null, 8, ["showDialog", "title", "message", "onNegativeClick", "onPositiveClick"])
  ]))
})